var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.2 37.2",
    style: {
      enableBackground: "new 0 0 37.2 37.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.1,33.6c-6.7,3.8-15.2,2.6-20.6-2.8C1,25.3-0.2,16.8,3.6,10.1C3.7,9.9,3.9,9.7,4,9.5C4.6,8.6,5.2,7.7,6,7 v1.8c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V5.2c0-0.4-0.3-0.7-0.7-0.7H3.1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7H5 C4.2,6.8,3.5,7.7,2.8,8.7C2.7,9,2.5,9.2,2.4,9.4c-4.1,7.2-2.9,16.4,3,22.3c3.6,3.6,8.4,5.4,13.2,5.4c3.1,0,6.3-0.8,9.1-2.4 c0.3-0.2,0.5-0.6,0.3-1C27.8,33.5,27.4,33.4,27.1,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,31.3h-1.9c0.8-0.9,1.6-1.8,2.2-2.8c0.1-0.2,0.3-0.5,0.4-0.7c4.1-7.3,2.8-16.4-3-22.3 c-5.9-5.9-15.1-7.1-22.3-3C9.1,2.6,9,3,9.2,3.4c0.2,0.3,0.6,0.5,1,0.3C16.8-0.2,25.3,1,30.8,6.4c5.4,5.4,6.6,13.9,2.8,20.6 c-0.1,0.2-0.3,0.4-0.4,0.6c-0.6,0.9-1.2,1.7-2,2.5v-1.8c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7V32c0,0.4,0.3,0.7,0.7,0.7 h3.6c0.4,0,0.7-0.3,0.7-0.7C34.8,31.6,34.5,31.3,34.1,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,26.9c2.2,2.2,5.2,3.4,8.3,3.4s6.1-1.2,8.3-3.4s3.4-5.2,3.4-8.3c0-3.1-1.2-6.1-3.4-8.3s-5.2-3.4-8.3-3.4 s-6.1,1.2-8.3,3.4s-3.4,5.2-3.4,8.3C6.8,21.7,8.1,24.7,10.3,26.9z M11.3,11.3c2-2,4.6-3,7.3-3s5.4,1.1,7.3,3c2,2,3,4.6,3,7.3 c0,2.8-1.1,5.4-3,7.3c-2,2-4.6,3-7.3,3s-5.4-1.1-7.3-3c-2-2-3-4.6-3-7.3C8.2,15.8,9.3,13.2,11.3,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,18.1c1.9,0,3.4-1.7,3.4-3.7s-1.5-3.7-3.4-3.7c-1.9,0-3.4,1.7-3.4,3.7S16.7,18.1,18.6,18.1z M18.6,12 c1.1,0,2,1,2,2.3s-0.9,2.3-2,2.3c-1.1,0-2-1-2-2.3S17.5,12,18.6,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,25.3h10.2c1,0,1.7-0.8,1.7-1.8c0-1.7-0.4-4.1-3.7-5c-0.4-0.1-0.8,0.1-0.9,0.5c-0.1,0.4,0.1,0.8,0.5,0.9 c2.2,0.6,2.6,1.9,2.6,3.7c0,0.2-0.1,0.3-0.3,0.3H13.5c-0.2,0-0.3-0.1-0.3-0.3c0-1.8,0.4-3.1,2.6-3.7c0.4-0.1,0.6-0.5,0.5-0.9 c-0.1-0.4-0.5-0.6-0.9-0.5c-3.3,0.9-3.7,3.3-3.7,5.1C11.8,24.5,12.6,25.3,13.5,25.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.17d5a8e614778be567e70035718a7f00.svg";
export { ForwardRef as ReactComponent };